var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M5 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v15.006a1 1 0 0 1-1.463.886L12 18l-5.537 2.892A1 1 0 0 1 5 20.006z"}})])
}
var staticRenderFns = []

export default { render: render }